// React
import React from "react";
// Notification library
import NotificationSystem from "react-notification-system";
// Internal notifier
import { initialiseNotifier } from "common/notifier";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class NotificationView extends React.Component {
    constructor(props) {
        super(props);
        this._notificationSystem = null;
    }
    componentDidMount() {
        this._notificationSystem = this.refs["notificationSystem"];
        initialiseNotifier(this._notificationSystem);
    }
    render() {
        return (React.createElement(NotificationSystem, { ref: "notificationSystem", allowHTML: true, noAnimation: false }));
    }
}
